import React from 'react';
import { Button } from './ui/Button';
import { useLanguage } from '../contexts/LanguageContext';
export function BookingFormSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-28 lg:py-36 px-6 bg-white" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="font-serif text-4xl lg:text-5xl mb-4 font-light" data-id="element-42">
            {t('contact.form.title')}
          </h2>
        </div>

        <form className="space-y-8" data-id="element-43">
          <div data-id="element-44">
            <label htmlFor="name" className="block text-[10px] uppercase tracking-[0.25em] mb-3 text-gray-500 font-light" data-id="element-45">
              {t('contact.form.name')}
            </label>
            <input type="text" id="name" className="w-full bg-[#FAFAF8] border-b border-[#1A1A1A]/10 p-4 focus:outline-none focus:border-[#D4AF37] transition-colors font-light" placeholder={t('contact.form.name.placeholder')} data-id="element-46" />
          </div>

          <div data-id="element-47">
            <label htmlFor="phone" className="block text-[10px] uppercase tracking-[0.25em] mb-3 text-gray-500 font-light" data-id="element-48">
              {t('contact.form.phone')}
            </label>
            <input type="tel" id="phone" className="w-full bg-[#FAFAF8] border-b border-[#1A1A1A]/10 p-4 focus:outline-none focus:border-[#D4AF37] transition-colors font-light" placeholder={t('contact.form.phone.placeholder')} data-id="element-49" />
          </div>

          <div data-id="element-50">
            <label htmlFor="message" className="block text-[10px] uppercase tracking-[0.25em] mb-3 text-gray-500 font-light" data-id="element-51">
              {t('contact.form.message')}
            </label>
            <textarea id="message" rows={5} className="w-full bg-[#FAFAF8] border-b border-[#1A1A1A]/10 p-4 focus:outline-none focus:border-[#D4AF37] transition-colors resize-none font-light" placeholder={t('contact.form.message.placeholder')} data-id="element-52"></textarea>
          </div>

          <div className="pt-6" data-id="element-53">
            <Button variant="primary" className="w-full" data-id="element-54">
              {t('contact.form.submit')}
            </Button>
          </div>
        </form>
      </div>
    </section>;
}